<div class="manage-locations white-content-page" style="padding-bottom: 1em ">
    <upsc-page-header [pageTitle]="'ManageShipFromLocations'|translate">
        <div page-actions>
            <button type="button" mat-raised-button (click)="addLocation()" class="page-action">
                {{'AddLocation'|translate}}
            </button>
        </div>
    </upsc-page-header>

    <div class="table-wrapper" [class.responsive-table]="dtOptions.responsive">
        <table datatable
               [dtOptions]="dtOptions"
               [dtTrigger]="dtTrigger"
               class="stripe"
               [hidden]="!locationList">
            <thead>
            <tr>
                <th class="all trigger-column"></th>
                <th>
                    {{'LocationName'|translate}}
                </th>
                <th>
                    {{'Address'|translate}}
                </th>
                <th class="all">
                    {{'SetAsDefault'|translate}}
                </th>
                <th class="all"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of locationList">
                <td class="trigger-cell"></td>
                <td> {{item.NickName}}
                </td>
                <td> {{item.StreetAddress + ', ' + item.City + ', '+ item.State + ', '+item.Zip + ', ' +
                    item.Country
                    }}
                </td>
                <td align="center">
                    <mat-radio-button (change)="makeDefaultLocation(item?.ContactId)"
                                      [checked]="item?.ContactId === defaultLocation"></mat-radio-button>
                    <!--<input type="radio"
                           class="blue-radio"
                           name="default"
                           (change)="makeDefaultLocation(item.ContactId)"
                           [(ngModel)]="defaultLocation"
                           [value]="item.ContactId"/>-->
                </td>
                <td>
                    <div class="actions">
                        <button type="button"
                                mat-raised-button
                                (click)="removeConfirmation(item.ContactId)"
                                color="primary">
                            {{'Remove'|translate}}
                        </button>
                        <button type="button"
                                mat-raised-button
                                (click)="editLocation(item.ContactId)"
                                class="alternative-button">
                            {{'Edit'|translate}}
                        </button>
                    </div>
                    <!--<a href="#deleteconfirmation" data-toggle="modal" data-dismiss="modal" class="btn btn-default btn-xs btn-grey" (click)="locationId=item.ContactId" >{{'Remove'|translate}}</a>-->
                    <!--<a href="#managelocation" data-toggle="modal" data-dismiss="modal" (click)="editLocation(item.ContactId)" class="btn btn-default btn-xs btn-green white-font " >{{'Edit'|translate}}</a>-->
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
